const userProp = (state, getters, rootState) => (prop) => {
  if (rootState.user.id && state.users[rootState.user.id] && state.users[rootState.user.id][prop]) {
    return state.users[rootState.user.id][prop]
  }
  return false
}
export default {
  userProp
}



// WEBPACK FOOTER //
// ./src/store/modules/user/locally/getters.js